import { render, staticRenderFns } from "./hzcontact.vue?vue&type=template&id=d8b8f3fe&scoped=true"
import script from "./hzcontact.vue?vue&type=script&lang=js"
export * from "./hzcontact.vue?vue&type=script&lang=js"
import style0 from "./hzcontact.vue?vue&type=style&index=0&id=d8b8f3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b8f3fe",
  null
  
)

export default component.exports